import * as React from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "./Button";

interface Props {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    classes?: Array<string>;
}

export default class BackButton extends React.Component<Props> {
    public render(): React.ReactNode {
        const classes = [ "button-back" ];

        if(Array.isArray(this.props.classes)) {
            classes.push(...this.props.classes);
        }

        return (
            <Button
                type="button"
                onClick={this.props.onClick}
                classes={classes}
                data-testid="back-button"
            >
                <FontAwesomeLight icon="long-arrow-left" />Back
            </Button>
        );
    }
}
